import { Controller } from "@hotwired/stimulus"

// Drives the two-column "Resources" mega-menu in the top nav.
// Mousing over a left-column trigger reveals the matching right-column panel.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  hover(event) {
    const key = event.params.key
    this.triggerTargets.forEach((t) => {
      t.dataset.active = String(t.dataset.sharedResourcesMenuKeyParam === key)
    })
    this.panelTargets.forEach((p) => {
      p.classList.toggle("hidden", p.dataset.key !== key)
    })
  }
}
